<template>
  <div class="chat_log">
    444
  </div>
</template>

<script>
export default {
  name: "chatLog"
}
</script>

<style scoped>

</style>
